<template>
  <!-- Height, text size and weight copy the theme's .btn, so the CTA reads as one of the site's
       own buttons on the conversion pages (#6331). -->
  <button
    :type="type"
    class="flex h-14 w-fit items-center gap-1 rounded-full px-10 text-base font-normal text-white transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-bright"
    :class="started || disabled ? 'cursor-default bg-green/60' : 'cursor-pointer bg-green hover:bg-green-hover'"
    :disabled="started || disabled"
  >
    <CheckIcon v-if="started" class="size-5" aria-hidden="true" />
    <slot />
    <ArrowRightIcon v-if="!started" class="size-6" aria-hidden="true" />
  </button>
</template>

<script setup lang="ts">
import ArrowRightIcon from '@/assets/svg/arrow-right.svg?component'
import CheckIcon from '@/assets/svg/check.svg?component'

withDefaults(
  defineProps<{
    /** The calculation has started: shows the check and stops reacting to clicks. */
    started?: boolean
    /** Not actionable yet, like waiting for data; same muted look, no check. */
    disabled?: boolean
    /** Submit inside a form, so Enter in a field submits too. */
    type?: 'button' | 'submit'
  }>(),
  { started: false, disabled: false, type: 'button' },
)
</script>
